import React from 'react';
import Link from 'gatsby-link';
import { slugify } from '../components/slugify';
import BackgroundImage from 'react-background-image-loader';

var BaseHref = 'http://46.4.51.11:1337';



const DetKarriere = ({ data }) => (

  <div className="jobsDetail bg-white">
  <div className="row">
   <h1>{data.strapiStellenangebote.Title}</h1>
    <p className="tags">{data.strapiStellenangebote.Job_Location}</p>
  </div>
  <div className="row">
      <BackgroundImage className="Job_BG" src={data.strapiMetadata.jobs_placeholder.publicURL} placeholder={BaseHref + data.strapiMetadata.placeholder_img.url}> </BackgroundImage>
  </div>
   
    <div className="row">
      <div className="col-md-2 desktop-only">
        <a href={data.strapiStellenangebote.Job_Download.publicURL} download={"Stellenausschreibung-" + slugify(data.strapiStellenangebote.Title) + '-' + slugify(data.strapiStellenangebote.Job_Location)+'.pdf'} target="_blank" type="application/octet-stream"><button>Download PDF</button></a>
      </div>
      <div className="col-md-10 col-xs-12 right">
        <p className="intro">Wir sind ein erfolgreiches und expandierendes Ingenieurunternehmen mit derzeit 25 Mitarbeitern im Bereich Geotechnik/Tunnelbau/Wasserbau mit Stammsitz in M&uuml;nchen. Eine unserer Kernkompetenzen haben wir im Ingenieur- und Verkehrswegebau, in dem wir als Planer, Pr&uuml;fer, Gutachter und Bau&uuml;berwacher tätig sind. Unsere Kompetenz ist aktuell z. B. in verschiedenen Abschnitten des Großprojekts Stuttgarts 21 sowie beim Großprojekt 2. S-Bahn-Stammstrecke M&uuml;nchen gefragt. Seit vielen Jahren sind wir auch &uuml;berregional und im Ausland mit unseren Teams vertreten.</p>
        <br />
        <h1><strong>Zur Verstärkung unseres Teams am Arbeitsort {data.strapiStellenangebote.Job_Location} suchen wir eine/n {data.strapiStellenangebote.Title}</strong></h1>
        
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <h3><strong>Ihre Aufgaben:</strong></h3>
            <div dangerouslySetInnerHTML={{ __html: data.strapiStellenangebote.Job_Tasks }} />
          </div>
          <div className="col-md-6 col-xs-12">
            <h3><strong>Ihr Profil:</strong></h3>
            <div dangerouslySetInnerHTML={{ __html: data.strapiStellenangebote.Job_Profile }} />
          </div>
        </div>
       
        <h3><strong>Wir bieten Ihnen:</strong></h3>
        <div dangerouslySetInnerHTML={{ __html: data.strapiStellenangebote.Job_More }} />
        <h3><strong>Interessiert?</strong></h3>
        <p>Dann freuen wir uns auf Ihre aussagekräftigen Unterlagen einschließlich Angabe Ihrer Gehaltsvorstellung und Ihres frühestmöglichen Eintrittstermins an:</p>
        <center><a href={"mailto:" + data.strapiStellenangebote.Job_Contact_Email + "?subject=Bewerbung " + data.strapiStellenangebote.Title + " / Standort " + data.strapiStellenangebote.Job_Location}><button>{data.strapiStellenangebote.Job_Contact_Email}</button></a></center>
        <br />
        <br />
        <p>{data.strapiStellenangebote.Job_Contact}</p>
      </div>
      </div>
    </div>      
          
);


export default DetKarriere;


export const KarriereQuery = graphql`
  query DetKarriereQuery($id: String!) {
    strapiStellenangebote(id: { eq: $id }) {
          id
          Title
          Job_Profile
          Job_Tasks
          Job_More
          Job_Contact
          Job_Contact_Email
          Job_Location
          Public
           Job_Download{
              publicURL
          }
    },
         strapiMetadata{
          SiteTitle
          Keywords
          jobs_placeholder{
            publicURL
            childImageSharp{
              sizes{
                src
              }
            }
          }
          placeholder_img{
            childImageSharp{
              sizes{
                src
              }
            }
          }
        }
  }
`




// WEBPACK FOOTER //
// ./src/templates/karriere_detail.js